/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, inject, OnInit } from '@angular/core';
import {SubscriptionTypeListService} from './subscription-type-list.service';
import {Observable} from "rxjs";
import { JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import {SubscriptionTypeVoModel} from "@well/domain";
import {ActivatedRoute, Router} from "@angular/router";
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { constants } from '@well/infra/constants';
import { SelectChangeEvent } from 'primeng/select';
import { EnvironmentService } from '@irian-ro/util-environment';
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-subscription-type-list-page',
  templateUrl: './subscription-type-list-page.component.html',
  styleUrls: ['./subscription-type-list-page.component.scss']
})
export class SubscriptionTypeListPageComponent implements OnInit {
  environmentService = inject(EnvironmentService)

  listResource: Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>> | undefined = undefined;

  companyTypesSelectItems: SelectItem[] = [];
  selectedCompanyType: SelectItem | undefined;
  lazyLoadEvent: LazyLoadEvent = {
    first: undefined,
    rows: undefined,
    sortField: undefined,
    sortOrder: undefined,
    multiSortMeta: undefined,
    filters: {},
    globalFilter: undefined,
  };

  constructor(private subscriptionTypeListService: SubscriptionTypeListService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.listResource = this.subscriptionTypeListService.getList(this.lazyLoadEvent);
    this.companyTypesSelectItems = constants.companyTypeList;
    if (!this.environmentService.getEnvironmentProperty("accessUnavailableFeatures")) {
      this.companyTypesSelectItems = this.companyTypesSelectItems.filter(item => item.value !== CompanyType.customer_with_fleet);
    }
  }

  addNew() {
    this.router.navigate(['new'], {relativeTo: this.activatedRoute});
  }

  onEdit(uuid: string) {
    this.router.navigate([uuid], {relativeTo: this.activatedRoute});
  }

  filterSubscriptions(changeEvent: SelectChangeEvent){
    this.lazyLoadEvent.filters = {companyType: {
      value: changeEvent.value,
      matchMode: 'equals'
    }};
    this.listResource = this.subscriptionTypeListService.getList(this.lazyLoadEvent);
  }

}
